var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useExtensionRegistry } from '@antv/xflow-core';
import { createFlowchartExtensionModule } from '../module';
export const FlowchartExtension = () => {
    /** 获取扩展Registry */
    const extensionRegistry = useExtensionRegistry();
    const config = React.useMemo(() => ({
        CONFIG_TYPE: 'FLOWCHART_EXTENSION',
        getConfig: () => __awaiter(void 0, void 0, void 0, function* () { }),
    }), []);
    React.useEffect(() => {
        /** 注册 extension 到 Registry */
        const disposable = extensionRegistry.addExtension({
            config: config,
            createModule: createFlowchartExtensionModule,
        });
        /** 添加 classname */
        extensionRegistry.addContainerClassNames('flowchart-extension-container');
        return () => {
            disposable.dispose();
        };
    }, [config, extensionRegistry]);
    return null;
};
//# sourceMappingURL=index.js.map